<template>
  <div>
    <v-collapse-group class="a-ui-tab ">
      <div class="a-ui-tab__block u-margin-b-24" v-for="(accreditation, idx) of accreditations" :key="accreditation.id">
        <v-collapse-wrapper>
          <div class="a-ui-tab__control-panel" v-collapse-toggle>
            <div class="a-ui-tab__control">
              <div class="a-ui-tab__arrow"></div>
              <div class="a-ui-tab__number-block">{{idx + 1}}</div>
              <div class="a-ui-tab__title">
                <span>
                  {{$t('labels.accreditation-valid-until')}}
                  <date-time tag="span" :value="accreditation.expired" :time="false"></date-time>
                </span>
              </div>
            </div>
          </div>

          <div class="a-ui-tab__content-block" v-collapse-content>
            <div class="a-ui-tab__content">
              <accreditation-history-item :acc="accreditation"></accreditation-history-item>
            </div>
          </div>
        </v-collapse-wrapper>
      </div>
    </v-collapse-group>
  </div>
</template>

<script>
  import AccreditationHistoryItem from './AccreditationHistoryItem';

  export default {
    components: {
      AccreditationHistoryItem
    },

    props: {
      profile: {
        type: Object,
        mandatory: true
      }
    },

    computed: {
      accreditations() {
        return this.profile.accreditations;
      }
    }
  }
</script>

<style scoped>

</style>
